module.exports = __webpack_public_path__ + "img/google.3344d376.png";